import * as React from 'react'
import { ReactNode } from 'react'
import { t } from 'ttag'
import YumButton, { YumButtonProps } from '../YumButton/YumButton'
import YumButtonGroup from '../YumButtonGroup/YumButtonGroup'
import { ButtonProps } from '@material-ui/core/Button'

interface IYumSubmitButtonProps extends Omit<YumButtonProps, 'children'> {
  text?: string
  submitInProgress?: boolean
}

const YumSubmitButton = ({ text, submitInProgress, ...props }: IYumSubmitButtonProps) => {
  return (
    <YumButton
      type="submit"
      showLoader={submitInProgress}
      disabled={submitInProgress}
      // Keep button visual weight while disabled.
      disableDisabledOpacity={true}
      {...props}
    >
      {text || t`Submit`}
    </YumButton>
  )
}

export default YumSubmitButton
